<template>
  <div class="animates-lists verticallyTop" :class="animate2.length>0?'':'no-middle-line'">
    <div class="aniamte-list-wrap left">
      <div class="animate-types" v-for="(animateType, index) in animate1" :key="'type_' + index">
        <ul class="animates-lists-ul">
          <li
            v-for="(animate, index) in animateType.list"
            :key="index"
            class="animates-lists-li"
            @click="selectAnimate(animate)"
          >
            <span :class="['icon', animate.iconClass]"></span>
            <span>{{ animate.name }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="aniamte-list-wrap right" v-if="animate2.length > 0">
      <div class="animate-types" v-for="(animateType, index) in animate2" :key="'type_' + index">
        <ul class="animates-lists-ul">
          <li
            v-for="(animate, index) in animateType.list"
            :key="index"
            class="animates-lists-li"
            @click="selectAnimate(animate)"
          >
            <span :class="['icon', animate.iconClass]"></span>
            <span>{{ animate.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { componentNames } from "dependencies/base"
import componentsMixIn from "./animateStyles.vue"
export default {
  name: "page-loading-animate",
  mixins: [componentsMixIn],
  components: {},
  props: {
    targetName: { type: String },
    type: { type: String }
  },
  data() {
    return {
      animate1: [],
      animate2: []
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  },
  mounted() {
    this.animate1 = this.animateStyles.slice(0, 2)
    this.animate2 = this.animateStyles.slice(2)
  },
  methods: {
    selectAnimate(animate) {
      // 默认为当前组件
      this.$emit("addAnimate", animate, { ...this.ids }, this.type)
    }
  }
}
</script>
